import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_6 = {
  class: "flex gap-2 flex-wrap"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "p-6"
};
const _hoisted_9 = {
  class: "mb-6 p-4 bg-slate-50 rounded-lg space-y-2"
};
const _hoisted_10 = {
  class: "flex items-center gap-3"
};
const _hoisted_11 = {
  class: "text-sm text-slate-900"
};
const _hoisted_12 = {
  key: 0,
  class: "flex items-center gap-3"
};
const _hoisted_13 = {
  class: "text-sm text-slate-900"
};
const _hoisted_14 = {
  key: 1,
  class: "flex items-center gap-3"
};
const _hoisted_15 = {
  class: "flex items-center gap-2"
};
const _hoisted_16 = {
  class: "w-6 h-6 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center text-white text-xs font-medium"
};
const _hoisted_17 = {
  class: "text-sm text-slate-900"
};
const _hoisted_18 = {
  key: 2,
  class: "flex items-center gap-3"
};
const _hoisted_19 = {
  class: "text-sm text-slate-900"
};
const _hoisted_20 = {
  key: 3,
  class: "flex items-center gap-3"
};
const _hoisted_21 = {
  class: "text-sm text-slate-900"
};
const _hoisted_22 = {
  class: "flex items-center gap-3 w-full"
};
const _hoisted_23 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_24 = ["disabled"];
const _hoisted_25 = {
  class: "p-6"
};
const _hoisted_26 = {
  class: "text-lg font-medium text-slate-900"
};
const _hoisted_27 = {
  class: "text-slate-600"
};
const _hoisted_28 = {
  class: "text-amber-600 font-medium"
};
const _hoisted_29 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_30 = ["disabled"];
import { ref, reactive, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { getOrderPage, getOrderDetail, updateOrderStatus } from '@/api/order';
import { getTraceList } from '@/api/trace';
import { getPlanPage } from '@/api/plan';
import { receiveBilling } from '@/api/billing';
import { updateTask } from '@/api/task';
import PlanDetailModal from '@/components/PlanDetailModal.vue';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import OrderDetailModal from '@/components/OrderDetailModal.vue';
import OrderFormModal from '@/components/OrderFormModal.vue';
import OrderListTable from '@/components/OrderListTable.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'OrderManagement',
  setup(__props) {
    const route = useRoute();
    const searchForm = reactive({
      keyword: '',
      status: '',
      planId: '',
      executorId: null,
      page: 1,
      size: 20
    });
    const pagination = reactive({
      current: 1,
      size: 20,
      total: 0,
      pages: 0
    });
    const loading = ref(false);
    const orderList = ref([]);
    const planList = ref([]);
    const orderDetail = ref(null);
    const traceList = ref([]);
    const showDetailModal = ref(false);
    const showPlanModal = ref(false);
    const selectedPlanData = ref(null);
    const selectedBilling = ref(null);
    const showBillingReceiveModal = ref(false);
    const receiveFormRef = ref(null);
    const receiveSubmitting = ref(false);

    // 订单编辑相关状态
    const showOrderEditModal = ref(false);
    const editOrderData = ref(null);

    // 审批相关状态
    const showApprovalDetailModal = ref(false);
    const selectedApprovalInstanceId = ref(null);

    // 任务编辑相关状态
    const showTaskEditModal = ref(false);
    const taskFormRef = ref(null);
    const taskSubmitting = ref(false);
    const selectedTask = ref(null);
    const taskFormData = reactive({
      status: 0,
      progress: 0,
      remark: ''
    });
    const receiveFormData = reactive({
      paidAmount: 0,
      payChannel: ''
    });
    const receiveRules = {
      paidAmount: [{
        required: true,
        message: '请输入收款金额',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          if (!value || value <= 0) {
            callback(new Error('收款金额必须大于0'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      payChannel: [{
        required: true,
        message: '请选择支付渠道',
        trigger: 'change'
      }]
    };
    const taskRules = {
      status: [{
        required: true,
        message: '请选择任务状态',
        trigger: 'change'
      }],
      progress: [{
        required: true,
        message: '请输入任务进度',
        trigger: 'blur'
      }, {
        type: 'number',
        min: 0,
        max: 100,
        message: '进度必须在0-100之间',
        trigger: 'blur'
      }]
    };
    const payChannelOptions = [{
      label: '微信',
      value: 'WECHAT'
    }, {
      label: '支付宝',
      value: 'ALIPAY'
    }, {
      label: '银行转账',
      value: 'BANK_TRANSFER'
    }, {
      label: '现金',
      value: 'CASH'
    }, {
      label: '其他',
      value: 'OTHER'
    }];
    const receiveRemainingAmount = computed(() => {
      if (!selectedBilling.value) return 0;
      return (selectedBilling.value.amount || 0) - (selectedBilling.value.paidAmount || 0);
    });

    // 快捷筛选标签
    const tabs = [{
      label: '全部',
      value: ''
    }, {
      label: '待审批',
      value: -1
    }, {
      label: '待确认',
      value: 0
    }, {
      label: '执行中',
      value: 1
    }, {
      label: '已完成',
      value: 2
    }, {
      label: '已取消',
      value: 3
    }, {
      label: '已驳回',
      value: 4
    }];
    const statusOptions = [{
      label: '待审批',
      value: -1
    }, {
      label: '待确认',
      value: 0
    }, {
      label: '执行中',
      value: 1
    }, {
      label: '已完成',
      value: 2
    }, {
      label: '已取消',
      value: 3
    }, {
      label: '已驳回',
      value: 4
    }];
    const loadOrders = async () => {
      loading.value = true;
      try {
        const params = {
          keyword: searchForm.keyword,
          status: searchForm.status !== '' ? searchForm.status : undefined,
          planId: searchForm.planId || undefined,
          executorId: searchForm.executorId || undefined,
          page: pagination.current,
          size: pagination.size
        };
        const data = await getOrderPage(params);
        orderList.value = data.records || [];
        pagination.current = data.current;
        pagination.size = data.size;
        pagination.total = data.total;
        pagination.pages = data.pages;
      } catch (error) {
        ElMessage.error('加载订单列表失败');
      } finally {
        loading.value = false;
      }
    };
    const loadPlans = async () => {
      try {
        const data = await getPlanPage({
          page: 1,
          size: 100
        });
        planList.value = data.records || [];
      } catch (error) {
        console.error('加载方案列表失败', error);
      }
    };
    const handleSearch = () => {
      pagination.current = 1;
      loadOrders();
    };
    const resetSearch = () => {
      searchForm.keyword = '';
      searchForm.status = '';
      searchForm.planId = '';
      searchForm.executorId = null;
      pagination.current = 1;
      loadOrders();
    };
    const handlePageChange = page => {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      loadOrders();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.current = 1;
      loadOrders();
    };
    const openDetailModal = async order => {
      try {
        orderDetail.value = await getOrderDetail(order.id);
        traceList.value = await getTraceList('ORDER', order.id);
      } catch (error) {
        ElMessage.error('加载订单详情失败');
      }
      showDetailModal.value = true;
    };
    const handleDetailRefresh = async () => {
      if (!orderDetail.value?.id) {
        return;
      }
      try {
        orderDetail.value = await getOrderDetail(orderDetail.value.id);
        traceList.value = await getTraceList('ORDER', orderDetail.value.id);
        loadOrders();
      } catch (error) {
        ElMessage.error(error?.message || '刷新订单详情失败');
      }
    };

    // 打开订单编辑弹窗
    const openEditModal = async order => {
      try {
        editOrderData.value = await getOrderDetail(order.id);
        showOrderEditModal.value = true;
      } catch (error) {
        ElMessage.error('加载订单详情失败');
      }
    };

    // 打开方案详情弹窗
    const openPlanDetail = order => {
      selectedPlanData.value = null;
      if (order.planId) {
        selectedPlanData.value = {
          id: order.planId
        };
      }
      showPlanModal.value = true;
    };
    const handleStatusChange = async ({
      order,
      status
    }) => {
      try {
        await updateOrderStatus({
          orderId: order.id,
          status
        });
        ElMessage.success('状态更新成功');
        loadOrders();
      } catch (error) {
        ElMessage.error(error.message || '状态更新失败');
      }
    };
    const isAmountApprovalInProgress = order => {
      return Number(order?.pendingApprovalStatus) === 0 && order?.pendingApprovalInstanceId != null;
    };
    const openApprovalDetailModal = order => {
      if (!order?.pendingApprovalInstanceId) {
        ElMessage.warning('暂无审批实例');
        return;
      }
      selectedApprovalInstanceId.value = order.pendingApprovalInstanceId;
      showApprovalDetailModal.value = true;
    };
    const handleOrderFormSuccess = async result => {
      ElMessage.success(isAmountApprovalInProgress(result) ? '已提交订单金额变更审批，审批通过后生效' : '订单修改成功');
      showOrderEditModal.value = false;
      await loadOrders();
      if (orderDetail.value?.id) {
        await handleDetailRefresh();
      }
    };

    // 打开收款弹窗
    const openReceiveModal = billing => {
      selectedBilling.value = billing;
      receiveFormData.paidAmount = receiveRemainingAmount.value;
      receiveFormData.payChannel = '';
      showBillingReceiveModal.value = true;
    };

    // 关闭收款弹窗
    const closeReceiveModal = () => {
      showBillingReceiveModal.value = false;
    };

    // 提交收款
    const handleReceiveSubmit = async () => {
      try {
        await receiveFormRef.value.validate();
      } catch {
        return;
      }
      receiveSubmitting.value = true;
      try {
        await receiveBilling({
          billingId: selectedBilling.value.id,
          paidAmount: receiveFormData.paidAmount,
          payChannel: receiveFormData.payChannel
        });
        ElMessage.success('收款成功');
        closeReceiveModal();
        // 刷新订单详情
        if (orderDetail.value) {
          orderDetail.value = await getOrderDetail(orderDetail.value.id);
        }
      } catch (error) {
        ElMessage.error(error.message || '收款失败');
      } finally {
        receiveSubmitting.value = false;
      }
    };

    // 收款成功回调
    // 已移至 handleReceiveSubmit 中直接处理

    // 任务状态改为已完成时，自动将进度同步为 100%
    const handleTaskStatusChange = val => {
      if (val === 2 && taskFormData.progress < 100) {
        taskFormData.progress = 100;
      }
    };

    // 任务编辑相关方法
    const openTaskEditModal = task => {
      selectedTask.value = task;
      // 只设置可编辑的字段
      taskFormData.status = task.status ?? 0;
      taskFormData.progress = task.progress || 0;
      taskFormData.remark = task.remark || '';
      showTaskEditModal.value = true;
    };
    const closeTaskEditModal = () => {
      showTaskEditModal.value = false;
      if (taskFormRef.value) {
        taskFormRef.value.resetFields();
      }
    };
    const handleTaskSubmit = async () => {
      try {
        await taskFormRef.value.validate();
      } catch {
        return;
      }
      taskSubmitting.value = true;
      try {
        // 根据API文档，需要传入 id、orderId 和可修改的字段
        await updateTask({
          id: selectedTask.value.id,
          orderId: selectedTask.value.orderId,
          status: taskFormData.status,
          progress: taskFormData.progress,
          remark: taskFormData.remark
        });
        ElMessage.success('任务更新成功');
        closeTaskEditModal();

        // 刷新订单详情
        if (orderDetail.value) {
          orderDetail.value = await getOrderDetail(orderDetail.value.id);
        }
      } catch (error) {
        ElMessage.error(error.message || '任务更新失败');
      } finally {
        taskSubmitting.value = false;
      }
    };

    // 从详情弹窗编辑订单
    const handleDetailEdit = order => {
      editOrderData.value = order;
      showDetailModal.value = false;
      showOrderEditModal.value = true;
    };

    // 执行人更换成功回调
    const handleExecutorChanged = async () => {
      await handleDetailRefresh();
    };
    onMounted(async () => {
      // 从路由参数中读取筛选条件
      const {
        id,
        orderId,
        keyword,
        status,
        planId,
        executorId,
        openDetail
      } = route.query;

      // 如果指定了订单ID且需要打开详情
      const targetOrderId = id || orderId;
      if (targetOrderId && openDetail === 'true') {
        try {
          orderDetail.value = await getOrderDetail(targetOrderId);
          traceList.value = await getTraceList('ORDER', targetOrderId);
          showDetailModal.value = true;
        } catch (error) {
          console.error('获取订单详情失败:', error);
          ElMessage.error('获取订单详情失败');
        }
        // 清除 query 参数，避免刷新页面重复弹窗
        window.history.replaceState({}, '', '/order');
      } else if (targetOrderId) {
        // 仅筛选，不打开详情
        searchForm.keyword = targetOrderId;
      }

      // 关键词搜索
      if (keyword) {
        searchForm.keyword = keyword;
      }

      // 状态筛选
      if (status !== undefined && status !== '') {
        searchForm.status = Number(status);
      }

      // 方案筛选
      if (planId) {
        searchForm.planId = planId;
      }

      // 执行人筛选
      if (executorId) {
        searchForm.executorId = executorId;
      }
      loadOrders();
      loadPlans();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "订单管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理服务订单，跟踪服务进度")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": "",
          "refresh-loading": loading.value,
          onRefresh: loadOrders
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: loading.value,
            onClick: handleSearch
          }, " 搜索 ", 8, _hoisted_3), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: loading.value,
            onClick: resetSearch
          }, " 重置 ", 8, _hoisted_4)]),
          extra: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, tab => {
            return _createElementVNode("button", {
              key: tab.value,
              onClick: $event => {
                searchForm.status = tab.value;
                handleSearch();
              },
              class: _normalizeClass(['px-3 py-1.5 rounded-full text-sm font-medium transition-colors', searchForm.status === tab.value ? 'bg-primary-100 text-primary-700' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'])
            }, _toDisplayString(tab.label), 11, _hoisted_7);
          }), 64))])])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.keyword = $event),
            type: "text",
            placeholder: "搜索订单编号、产品名称",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchForm.keyword]]), _cache[15] || (_cache[15] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: searchForm.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleSearch
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, s => {
              return _createVNode(_component_el_option, {
                key: s.value,
                label: s.label,
                value: s.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: searchForm.planId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.planId = $event),
            placeholder: "请选择方案",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleSearch
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部方案",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planList.value, p => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: p.id,
                label: p.name,
                value: p.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(UserSelector, {
            modelValue: searchForm.executorId,
            "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => searchForm.executorId = $event), handleSearch],
            class: "selector-compact filter-bar-field",
            multiple: false,
            placeholder: "请选择执行人"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createVNode(OrderListTable, {
          orders: orderList.value,
          loading: loading.value,
          pagination: pagination,
          onDetail: openDetailModal,
          onPlanClick: openPlanDetail,
          onEdit: openEditModal,
          onApprovalDetail: openApprovalDetailModal,
          onStatusChange: handleStatusChange,
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["orders", "loading", "pagination"])]), _createVNode(OrderDetailModal, {
          visible: showDetailModal.value,
          "onUpdate:visible": _cache[4] || (_cache[4] = $event => showDetailModal.value = $event),
          orderDetail: orderDetail.value,
          traceList: traceList.value,
          onReceive: openReceiveModal,
          onEditTask: openTaskEditModal,
          onEdit: handleDetailEdit,
          onApprovalDetail: openApprovalDetailModal,
          onRefreshDetail: handleDetailRefresh,
          onExecutorChanged: handleExecutorChanged
        }, null, 8, ["visible", "orderDetail", "traceList"]), _createVNode(ApprovalDetailModal, {
          modelValue: showApprovalDetailModal.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showApprovalDetailModal.value = $event),
          "instance-id": selectedApprovalInstanceId.value,
          type: "order",
          title: "审批详情"
        }, null, 8, ["modelValue", "instance-id"]), _createVNode(PlanDetailModal, {
          visible: showPlanModal.value,
          "onUpdate:visible": _cache[6] || (_cache[6] = $event => showPlanModal.value = $event),
          planData: selectedPlanData.value
        }, null, 8, ["visible", "planData"]), _createVNode(OrderFormModal, {
          visible: showOrderEditModal.value,
          "onUpdate:visible": _cache[7] || (_cache[7] = $event => showOrderEditModal.value = $event),
          isEdit: true,
          editData: editOrderData.value,
          onSuccess: handleOrderFormSuccess
        }, null, 8, ["visible", "editData"]), _createVNode(AppModal, {
          visible: showTaskEditModal.value,
          size: "2xl",
          scrollable: false,
          onClose: closeTaskEditModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
          }, [_cache[17] || (_cache[17] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "编辑任务", -1)), _createElementVNode("button", {
            onClick: closeTaskEditModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[18] || (_cache[18] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "任务名称", -1)), _createElementVNode("span", _hoisted_11, _toDisplayString(selectedTask.value?.name), 1)]), selectedTask.value?.type ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[19] || (_cache[19] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "任务类型", -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(selectedTask.value?.type), 1)])) : _createCommentVNode("", true), selectedTask.value?.assigneeName ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[20] || (_cache[20] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "负责人", -1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(selectedTask.value?.assigneeName?.charAt(0)), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(selectedTask.value?.assigneeName), 1)])])) : _createCommentVNode("", true), selectedTask.value?.startTime ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_cache[21] || (_cache[21] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "开始时间", -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$formatDateTime(selectedTask.value?.startTime)), 1)])) : _createCommentVNode("", true), selectedTask.value?.endTime ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_cache[22] || (_cache[22] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-500 w-20"
          }, "结束时间", -1)), _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$formatDateTime(selectedTask.value?.endTime)), 1)])) : _createCommentVNode("", true)]), _createVNode(_component_el_form, {
            ref_key: "taskFormRef",
            ref: taskFormRef,
            model: taskFormData,
            rules: taskRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "任务状态",
              prop: "status"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: taskFormData.status,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => taskFormData.status = $event),
                placeholder: "请选择任务状态",
                class: "w-full",
                onChange: handleTaskStatusChange
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "待开始",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "进行中",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "已完成",
                  value: 2
                }), _createVNode(_component_el_option, {
                  label: "已暂停",
                  value: 3
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "任务进度",
              prop: "progress"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_slider, {
                modelValue: taskFormData.progress,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => taskFormData.progress = $event),
                min: 0,
                max: 100,
                class: "flex-1"
              }, null, 8, ["modelValue"]), _createVNode(_component_el_input_number, {
                modelValue: taskFormData.progress,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => taskFormData.progress = $event),
                min: 0,
                max: 100,
                class: "w-25"
              }, null, 8, ["modelValue"]), _cache[23] || (_cache[23] = _createElementVNode("span", {
                class: "text-slate-600"
              }, "%", -1))])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: taskFormData.remark,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => taskFormData.remark = $event),
                type: "textarea",
                rows: 4,
                placeholder: "请输入备注信息"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("button", {
            type: "button",
            onClick: closeTaskEditModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            type: "button",
            disabled: taskSubmitting.value,
            onClick: handleTaskSubmit,
            class: "btn-primary"
          }, _toDisplayString(taskSubmitting.value ? '保存中...' : '保存'), 9, _hoisted_24)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showBillingReceiveModal.value,
          size: "md",
          scrollable: false,
          onClose: closeReceiveModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
          }, [_cache[25] || (_cache[25] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "账单收款", -1)), _createElementVNode("button", {
            onClick: closeReceiveModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_form, {
            ref_key: "receiveFormRef",
            ref: receiveFormRef,
            model: receiveFormData,
            rules: receiveRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "应收金额"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_26, "¥" + _toDisplayString(selectedBilling.value?.amount?.toLocaleString()), 1)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "已收金额"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_27, "¥" + _toDisplayString(selectedBilling.value?.paidAmount?.toLocaleString() || '0'), 1)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "待收金额"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_28, "¥" + _toDisplayString(receiveRemainingAmount.value.toLocaleString()), 1)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "收款金额",
              prop: "paidAmount"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: receiveFormData.paidAmount,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => receiveFormData.paidAmount = $event),
                min: 0.01,
                max: receiveRemainingAmount.value,
                precision: 2,
                step: 100,
                class: "w-50"
              }, null, 8, ["modelValue", "max"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "支付渠道",
              prop: "payChannel"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: receiveFormData.payChannel,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => receiveFormData.payChannel = $event),
                placeholder: "请选择支付渠道",
                class: "w-50"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(payChannelOptions, ch => {
                  return _createVNode(_component_el_option, {
                    key: ch.value,
                    label: ch.label,
                    value: ch.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("button", {
            type: "button",
            onClick: closeReceiveModal,
            class: "btn-secondary"
          }, "取消"), _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            disabled: receiveSubmitting.value,
            onClick: handleReceiveSubmit,
            class: "btn-primary"
          }, [...(_cache[26] || (_cache[26] = [_createTextVNode("确认收款", -1)]))], 8, _hoisted_30)), [[_directive_permission, 'billing:receive']])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};